import React, { useRef, useState, useEffect } from "react";

function ClickPicture(props) {
  var videoRef = useRef(null);
  var canvasRef = useRef(null);
  var [ocrText, setOcrText] = useState("");
  var [extractedData, setExtractedData] = useState({});
  var [processing, setProcessing] = useState(false);
  var [progress, setProgress] = useState(0);
  var [imagePreview, setImagePreview] = useState(null);

  useEffect(function () {
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then(function (stream) {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch(function (err) {
        console.error("Camera error:", err);
      });
  }, []);

  function handleScan() {
    setProcessing(true);
    setProgress(0);
    setOcrText("");
    setExtractedData({});

    var video = videoRef.current;
    var fullCanvas = canvasRef.current;
    var context = fullCanvas.getContext("2d");

    fullCanvas.width = video.videoWidth;
    fullCanvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, fullCanvas.width, fullCanvas.height);

    var thumbnailCanvas = document.createElement("canvas");
    var thumbWidth = 200;
    var thumbHeight = (thumbWidth / fullCanvas.width) * fullCanvas.height;

    thumbnailCanvas.width = thumbWidth;
    thumbnailCanvas.height = thumbHeight;

    var thumbContext = thumbnailCanvas.getContext("2d");
    thumbContext.drawImage(
      fullCanvas,
      0,
      0,
      fullCanvas.width,
      fullCanvas.height,
      0,
      0,
      thumbWidth,
      thumbHeight
    );

    var thumbnailDataURL = thumbnailCanvas.toDataURL("image/jpeg", 0.7);

    setImagePreview(thumbnailDataURL);
    setProcessing(false);

    if (props.onParsedData) {
      props.onParsedData(thumbnailDataURL);
    }
  }

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h2 className="text-xl font-bold mb-2">Scan Payment Receipt</h2>

      <video
        ref={videoRef}
        autoPlay
        playsInline
        className="rounded-md shadow"
        style={{ width: "40vw", height: "auto", border: "2px solid #ccc" }}
      />

      <canvas
        ref={canvasRef}
        style={{ width: "40vw", height: "auto", display: "none" }}
      />

      <div className="mt-4 flex justify-center space-x-4">
        <button
          onClick={handleScan}
          className="bg-green-600 text-white px-4 py-2 rounded shadow"
        >
          Capture
        </button>
        {props.onClose ? (
          <button
            onClick={props.onClose}
            className="bg-gray-600 text-white px-4 py-2 rounded shadow"
          >
            Cancel
          </button>
        ) : null}
      </div>

      {imagePreview ? (
        <img
          src={imagePreview}
          alt="Captured"
          className="mt-4 rounded shadow w-full max-w-sm mx-auto"
        />
      ) : null}
    </div>
  );
}

export default ClickPicture;
